import request from '@/utils/request'

export function getChannel() {
  return request({
    url: '/index/service/getChannel',
    headers: {
      // isToken: false
    },
    method: 'post',
  })
}

export function getServiceData(query) {
  return request({
    url: '/index/service/getServiceData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getCorrelationMenu() {
  return request({
    url: '/index/index/getCorrelationMenu',
    headers: {
      // isToken: false
    },
    method: 'post'
  })
}

export function queryCollege(query) {
  return request({
    url: '/index/index/queryCollege',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}


export function calcuCorrelation(query) {
  return request({
    url: '/index/index/calcuCorrelation',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getThirdIndustryData(query) {
  return request({
    url: '/index/service/getThirdIndustryData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getIndustryData(query) {
  return request({
    url: '/index/service/getIndustryData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getThesisData(query) {
  return request({
    url: '/index/service/getThesisData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getMaterialData(query) {
  return request({
    url: '/index/service/getMaterialData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getEduData(query) {
  return request({
    url: '/index/service/getEduData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getServiceConfigData(query) {
  return request({
    url: '/index/service/getServiceConfigData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function exportIndustryData(query) {
  return request({
    url: '/index/service/exportIndustryData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function exportThirdIndustryData(query) {
  return request({
    url: '/index/service/exportThirdIndustryData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function exportEduData(query) {
  return request({
    url: '/index/service/exportEduData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getMajorMatchList(query) {
  return request({
    url: '/index/service/getMajorMatchList',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function createMajorMatch(query) {
  return request({
    url: '/index/service/createMajorMatch',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getJobList(query) {
  return request({
    url: '/index/service/getJobList',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getCreateMatchConfig(query) {
  return request({
    url: '/index/service/getCreateMatchConfig',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getMatchDataSourcePage(query) {
  return request({
    url: '/index/service/getMatchDataSourcePage',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getMatchTrend(query) {
  return request({
    url: '/index/service/getMatchTrend',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getMatchFactorPage(query) {
  return request({
    url: '/index/service/getMatchFactorPage',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function factorChange(query) {
  return request({
    url: '/index/service/factorChange',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getMatchExpandPage(query) {
  return request({
    url: '/index/service/getMatchExpandPage',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function expandFactorChange(query) {
  return request({
    url: '/index/service/expandFactorChange',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getMatchTalentPage(query) {
  return request({
    url: '/index/service/getMatchTalentPage',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function skillFactorChange(query) {
  return request({
    url: '/index/service/skillFactorChange',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getMatchFocusPage(query) {
  return request({
    url: '/index/service/getMatchFocusPage',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function focusFactorChange(query) {
  return request({
    url: '/index/service/focusFactorChange',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getMatchCalcuPage(query) {
  return request({
    url: '/index/service/getMatchCalcuPage',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function calcuFactorChange(query) {
  return request({
    url: '/index/service/calcuFactorChange',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getMatchCalcuMajor(query) {
  return request({
    url: '/index/service/getMatchCalcuMajor',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function addMatchCalcuMajor(query) {
  return request({
    url: '/index/service/addMatchCalcuMajor',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function removeMatchCalcuMajor(query) {
  return request({
    url: '/index/service/removeMatchCalcuMajor',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getMatchCompare(query) {
  return request({
    url: '/index/service/getMatchCompare',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getMatchStandard(query) {
  return request({
    url: '/index/service/getMatchStandard',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function updateMatchStandard(query) {
  return request({
    url: '/index/service/updateMatchStandard',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function exportMajorMatch(query) {
  return request({
    url: '/index/service/exportMajorMatch',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getMajorMatchDownloadUrl(query) {
  return request({
    url: '/index/service/getMajorMatchDownloadUrl',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}


export function changeMatchData(query) {
  return request({
    url: '/index/service/changeMatchData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function exportMatchExplain(query) {
  return request({
    url: '/index/service/exportMatchExplain',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}


export function streamJobReport(query) {
  return request({
    url: '/index/service/streamJobReport',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function delMatch(query) {
  return request({
    url: '/index/service/delMatch',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function exportJobReport(query) {
  return request({
    url: '/index/service/exportJobReport',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function queryCareerList(query) {
  return request({
    url: '/index/service/queryCareerList',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getDeviationList(query) {
  return request({
    url: '/index/service/getDeviationList',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getDeviationConfig(query) {
  return request({
    url: '/index/service/getDeviationConfig',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function createDeviation(query) {
  return request({
    url: '/index/service/createDeviation',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getDvnGdpData(query) {
  return request({
    url: '/index/service/getDvnGdpData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getDvnJobData(query) {
  return request({
    url: '/index/service/getDvnJobData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getDvnEnrollData(query) {
  return request({
    url: '/index/service/getDvnEnrollData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getDvnResult(query) {
  return request({
    url: '/index/service/getDvnResult',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function deleteDeviation(query) {
  return request({
    url: '/index/service/deleteDeviation',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function exportDeviation(query) {
  return request({
    url: '/index/service/exportDeviation',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}


export function getMismatchConfig(query) {
  return request({
    url: '/index/service/getMismatchConfig',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getMismatchList(query) {
  return request({
    url: '/index/service/getMismatchList',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function deleteMismatch(query) {
  return request({
    url: '/index/service/deleteMismatch',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function createMismatch(query) {
  return request({
    url: '/index/service/createMismatch',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getMisGdpData(query) {
  return request({
    url: '/index/service/getMisGdpData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getMisJobData(query) {
  return request({
    url: '/index/service/getMisJobData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}	

export function getMisEduData(query) {
  return request({
    url: '/index/service/getMisEduData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}	

export function getMisOtherData(query) {
  return request({
    url: '/index/service/getMisOtherData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}	

export function getMisRateData(query) {
  return request({
    url: '/index/service/getMisRateData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}	

export function exportMisResult(query) {
  return request({
    url: '/index/service/exportMisResult',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}	

export function updateMisData(query) {
  return request({
    url: '/index/service/updateMisData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}	

export function updateDvnData(query) {
  return request({
    url: '/index/service/updateDvnData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}	

export function getFitConfig(query) {
  return request({
    url: '/index/service/getFitConfig',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}	

export function getFitList(query) {
  return request({
    url: '/index/service/getFitList',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}	

export function getDegreeMajorTopList(query) {
  return request({
    url: '/index/service/getDegreeMajorTopList',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}	

export function createFit(query) {
  return request({
    url: '/index/service/createFit',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}	

export function deleteFit(query) {
  return request({
    url: '/index/service/deleteFit',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}	

export function getFitEnrollData(query) {
  return request({
    url: '/index/service/getFitEnrollData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}	

export function getTargetFitConfig(query) {
  return request({
    url: '/index/service/getTargetFitConfig',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}	

export function updateFitBaseConfig(query) {
  return request({
    url: '/index/service/updateFitBaseConfig',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}	

export function updateFitIndustryConfig(query) {
  return request({
    url: '/index/service/updateFitIndustryConfig',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}	

export function getFitEmployeePageData(query) {
  return request({
    url: '/index/service/getFitEmployeePageData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}	

export function getFitCalcuEnrollPageData(query) {
  return request({
    url: '/index/service/getFitCalcuEnrollPageData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}	

export function getFitEmployeeCalcuPageData(query) {
  return request({
    url: '/index/service/getFitEmployeeCalcuPageData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}	

export function createDownloadDeviationOrder(query) {
  return request({
    url: '/index/service/createDownloadDeviationOrder',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}	
